import { Component } from '@theme/component';
import { translateSubtree } from '@theme/utilities';

const selectors = {
  DRAWER: '#product-description',
  TAB: '.product-description-tab',
  RADIO: '.product-description-radio',
  PANEL_TEMPLATE: 'template.product-description-panel',
};

class ProductDescription extends Component {
  #drawer = this.querySelector(selectors.DRAWER);
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;

    this.#drawer?.addEventListener('dialog:open', this.#handleContent, { signal });
    this.addEventListener('change', this.#syncTab, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController.abort();
  }

  #handleContent = () => {
    this.#drawer?.querySelectorAll(selectors.PANEL_TEMPLATE).forEach((template) => {
      if (!(template instanceof HTMLTemplateElement)) return;

      const div = document.createElement('div');

      div.className = template.className;
      div.append(template.content);
      template.closest(selectors.TAB)?.after(div);
      template.remove();

      // Was inert inside a <template> (Weglot never saw it) — translate now it's live.
      translateSubtree(div);
    });
  };

  #syncTab = (/** @type {Event} */ event) => {
    if (!(event.target instanceof Element)) return;

    if (this.#drawer?.contains(event.target)) return;

    const radio = event.target.closest(selectors.RADIO);

    if (!radio) return;

    const index = [...this.querySelectorAll(selectors.RADIO)].indexOf(radio);
    const drawerRadio = this.#drawer?.querySelectorAll(selectors.RADIO)[index];

    if (drawerRadio instanceof HTMLInputElement) drawerRadio.checked = true;
  };
}

if (!customElements.get('product-description')) {
  customElements.define('product-description', ProductDescription);
}
